import { useState, useEffect, useCallback } from "react";

// =====================================================================
// Hinweis-Badges für den Home-Kreis.
// Badges werden von /api/me/notifications gelesen (Abfrage alle 60 s);
// liefert der Hub keinen Endpunkt, bleibt die Liste leer.
// =====================================================================

interface NotificationBadge {
  appId: string;
  count: number;
}

export function useLauncherBadges() {
  const [badges, setBadges] = useState<NotificationBadge[]>([]);

  useEffect(() => {
    let abort = false;
    const fetchBadges = () => {
      fetch("/api/me/notifications", { credentials: "include" })
        .then((r) => (r.ok ? r.json() : { badges: [] }))
        .then((data: { badges?: NotificationBadge[] }) => {
          if (!abort && data.badges) setBadges(data.badges);
        })
        .catch(() => {
          /* silent */
        });
    };
    fetchBadges();
    const interval = setInterval(fetchBadges, 60_000);
    return () => {
      abort = true;
      clearInterval(interval);
    };
  }, []);

  const getBadge = useCallback(
    (appId: string): number => badges.find((b) => b.appId === appId)?.count ?? 0,
    [badges],
  );

  return { getBadge, badges };
}
